import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import classNames from "classnames";

import ChangePassword from "./sub/ChangePassword";
import Company from "./sub/Company";
import Profile from "./sub/Profile";
import PageTitle from "../../common/PageTitle";
import { Link, useLocation } from "react-router-dom";
import { destroyAuthentication } from "../../utils/user";
import { Routes } from "../../utils/routes";

const SettingsPage = () => {
  const [tab, setTab] = useState("");
  const location = useLocation();

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const t = searchParams.get("tab");
    if (t === "company") {
      setTab("company")
    } else if (t === "privacy") {
      setTab("privacy")
    } else {
      setTab("profile")
    }
  }, [location.search]);

  const handleLogout = (e) => {
    e.preventDefault();
    destroyAuthentication();
    window.location.href = Routes.SignIn;
  };

  return (
    <>
      <Helmet>
        <title>Turgoil - Seaded</title>
        <meta name="viewport" content="width=device-width, initial-scale=1.0, user-scalable=no" />
      </Helmet>
      <PageTitle>Seaded</PageTitle>

      <div className="settings">
        <div className="settings__navigation">
          <ul>
            <li>
              <Link
                className={classNames("settings__navigation-link", {
                  "settings__navigation-link--active": tab === "profile"
                })}
                to="?tab=profile"
              >
                <i className="bi bi-person" /> Konto
              </Link>
            </li>
            <li>
              <Link
                className={classNames("settings__navigation-link", {
                  "settings__navigation-link--active": tab === "privacy"
                })}
                to="?tab=privacy"
              >
                <i className="bi bi-shield-check" /> Privaatsus
              </Link>
            </li>
            <li>
              <Link
                className={classNames("settings__navigation-link", {
                  "settings__navigation-link--active": tab === "company"
                })}
                to="?tab=company"
              >
                <i className="bi bi-duffle-fill" /> Ettevõte
              </Link>
            </li>
            <li>
              <Link
                className={classNames("settings__navigation-link")}
                onClick={handleLogout}
                to="#"
              >
                <i className="bi bi-box-arrow-right" /> Logi välja
              </Link>
            </li>
          </ul>
        </div>

        <div className="settings__content">
          {tab === "profile" && (
            <Profile />
          )}
          {tab === "privacy" && (
            <ChangePassword />
          )}
          {tab === "company" && (
            <Company />
          )}
        </div>
      </div>
    </>
  );
}

export default SettingsPage;
